// extracted by css-extract-rspack-plugin
export default {"ellipsis":"_9fe8969d","tooltipContents":"_fdc4b987","tooltipGoButton":"_d4910aa3"};